module.exports = __webpack_public_path__ + "image/footer-icon4a.png";